export enum ExecutiveSummaryRequestEnum {
    PhaseAnalysisItem,
    Infraction,
    All
}